export const FeatureFlags = {
  JOURNEY_DATE_REWORK: 'journey-date-rework',
  JOURNEY_ANALYTICS: 'journey-analytics',
  CONCORDE_PRODUCT_CARD: 'journey-concorde-product-card',
  PRODUCT_NUMBER_INJECTION: 'journey-product-number-injection',
  ACTIVE_JOURNEY: 'journey-publish',
  PRODUCT_TILE_LAYOUT: 'journey-product-tile-layout',
  CONCORDE_DATE_BLOCK: 'journey-concorde-date-block',
  TETRAEDER_API: 'journey-tetraeder-api',
  CONCORDE_IMAGE_BLOCK: 'journey-concord-image',
  CONCORDE_PARAGRAPH_BLOCK: 'journey-concord-paragraph',
  CONCORDE_HYPERLINK_BUTTON: 'journey-concorde-hyperlink-button',
  CONCORDE_SUCCESS_CONFIRMATION: 'journey-concorde-success-confirmation',
  CONCORDE_ACTION_BAR: 'journey-concorde-action-bar',
  CONCORDE_TEXT_INPUT: 'journey-text-input-block',
  CONCORDE_USER_SUMMARY: 'journey-concorde-user-summary'
}
